export default __webpack_public_path__ + "media/src/assets/images/warehouse-6f4c987bb96040d96d510929dbb57c01.svg";